export default (theme) => {
  return `
  .mu-popover{
    background: ${theme.background.paper};
  }
  `;
};



// WEBPACK FOOTER //
// ./src/muse-ui/Popover/theme.js